<template>
  <NsiTable
    :pageTitle="pageTitle"
    :apiRoute="apiRoute"
    :apiRouteSecond="apiRouteSecond"
    :cardName="cardName"
    :canEdit="canEdit"
    :isEventTypes="true"
  />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'MpkEventTypes',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Типы мероприятий',
        canEdit: true,
        apiRoute: 'mpkeventtype',
        apiRouteSecond: 'mpkEventTypeCategory',
        cardName: 'MpkEventTypeCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
